/**
 * Docs (eIFU) API configuration.
 * Source (same build for all envs):
 * - K8s: ConfigMap spinesim-front-config supplies REACT_APP_DOCS_API_URL at runtime (envFrom).
 * - Local: set in docker-compose or .env (REACT_APP_DOCS_API_URL).
 * When not set or empty, docs integration is disabled (placeholder PDF; no "Browse all"; IFU link no-op).
 */
const getDocsApiBaseUrlFromEnv = () => {
  const v = process.env.REACT_APP_DOCS_API_URL;
  return typeof v === "string" ? v.trim() : "";
};

const docsApiBaseUrl = getDocsApiBaseUrlFromEnv();

export const getDocsApiBaseUrl = () => docsApiBaseUrl;

export const isDocsEnabled = () => docsApiBaseUrl.length > 0;

/** Version string sent to Docs API when resolving eIFU. */
export const getEifuVersion = () => {
  const v = process.env.REACT_APP_EIFU_VERSION || "";
  return typeof v === "string" ? v.trim() : "";
};

/** eIFU resolve path (relative to docs API base). */
export const DOCS_EIFU_RESOLVE_PATH = "/api/docs/eifu/resolve";

/** SLA (Software License Agreement) resolve path (relative to docs API base). Blob layout: `SLA/{version}/{filename}`. */
export const DOCS_SLA_RESOLVE_PATH = "/api/docs/sla/resolve";

/** Docs directory UI path (relative to docs API base). */
export const DOCS_UI_PATH = "/ui";

export const getDocsEifuResolveUrl = version => {
  if (!docsApiBaseUrl) return null;
  const params = new URLSearchParams();
  if (version) params.set("version", version);
  const query = params.toString();
  return `${docsApiBaseUrl.replace(/\/$/, "")}${DOCS_EIFU_RESOLVE_PATH}${query ? `?${query}` : ""}`;
};

export const getDocsSlaResolveUrl = version => {
  if (!docsApiBaseUrl) return null;
  const params = new URLSearchParams();
  if (version) params.set("version", version);
  const query = params.toString();
  return `${docsApiBaseUrl.replace(/\/$/, "")}${DOCS_SLA_RESOLVE_PATH}${query ? `?${query}` : ""}`;
};

export const getDocsUiUrl = () =>
  docsApiBaseUrl ? `${docsApiBaseUrl.replace(/\/$/, "")}${DOCS_UI_PATH}` : null;
